<div class="c-contenedor">

    <div class="row">
        <div class="col-12 p-0">
            <img class="icon-close pr-10" (click)="onCloseClick()" src="assets/icons/ico-close.png" alt="cerrar">
        </div>
    </div>
    <div class="row">
        <ng-container *ngIf="data.icon">
            <img class="icon-bloqueo" src="assets/icons/icon-bloqueo.svg" alt="icon">
        </ng-container>
        <div class="col-12">
            <h1 mat-dialog-title class="c-titulo-dialogo"> {{ data.title }} </h1>

            <mat-dialog-content class="c-titulo-subtitulo" [innerHTML]="data.description"> </mat-dialog-content>

            <mat-dialog-actions>
                <button (click)="onActionClick()" class="btn-primary-tbk mx-auto dis">{{ data.actionButton }}</button>
            </mat-dialog-actions>
        </div>
    </div>
</div>